import { createContext } from 'react';
export var SearchResultContext = createContext({
    onClose: function () {
        /* noop */
    },
    isLoaded: false,
    isLoading: false,
    query: '',
});
SearchResultContext.displayName = 'SearchResultContext';
export var SearchResultContextProvider = SearchResultContext.Provider;
